import '../scss/main.scss';
// import $ from 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Plyr from 'plyr';
import { dropdown } from './dropdown.js'
import './multi-step-form.js'

if (document.querySelector('.swiper') !== null) {
    const swiper = new Swiper('.swiper', {
        speed: 400,
        direction: 'horizontal',
        loop: true,
        parallax: true,

        // Pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}

if (document.querySelector('.player') !== null) {
    const player = new Plyr('.player');
}

dropdown($('select.dropdown'));
    const btn = $("button.mobile-menu-button");
    const btnClose = $("button.mobile-menu-close");
    const menu = $(".mobile-menu");

    btn.on("click", () => {
        menu.toggleClass("hidden");
    });
    btnClose.on("click", () => {
        menu.toggleClass("hidden");
    });